import { useFetcher } from '@remix-run/react';
import { useTranslation } from 'react-i18next';

import { type SubscriberPreference, SubscriberPreferenceType } from '~/interfaces/subscriber_preferences';

import useToast from '~/hooks/useToast';

import { usePreferencesContext } from '../../_context/usePreferencesContext';
import BooleanField from './BooleanField';
import DropdownField from './DropdownField';
import MultipleChoiceField from './MultipleChoiceField';
import TextField from './TextField';

interface Props {
  preference: SubscriberPreference;
}

const Preference = ({ preference }: Props) => {
  const { subscription } = usePreferencesContext();
  const { t } = useTranslation('', { keyPrefix: 'preferences' });

  const fetcher = useFetcher<{ toast: any }>();
  const fetcherData = fetcher.data;

  useToast(fetcherData?.toast);

  const handleChange = (customFieldValue: any) => {
    const formData = new FormData();
    formData.append('preferences_success_message', t('toast.success'));
    formData.append('preferences_error_message', t('toast.error'));
    formData.append('subscriber_id', subscription?.subscriber_id || '');
    formData.append('preference_value', customFieldValue);
    formData.append('preference_id', preference.id);

    fetcher.submit(formData, {
      method: 'patch',
      action: '/update_subscriber_preference',
    });
  };

  return (
    <>
      {preference.preference_type === SubscriberPreferenceType.BOOLEAN ? (
        <BooleanField onChange={handleChange} preference={preference} />
      ) : null}
      {preference.preference_type === SubscriberPreferenceType.MULTIPLE_CHOICE ? (
        <MultipleChoiceField onChange={handleChange} preference={preference} />
      ) : null}
      {preference.preference_type === SubscriberPreferenceType.TEXT ? (
        <TextField onChange={handleChange} preference={preference} />
      ) : null}
      {preference.preference_type === SubscriberPreferenceType.DROPDOWN ? (
        <DropdownField onChange={handleChange} preference={preference} />
      ) : null}
    </>
  );
};

export default Preference;
